import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import FertilizerModal from '@/assets/common/Modal/FertilizerModal/FertilizerModal.vue';
import { FertilizerModel } from "@/types/Component";
import { toCamel } from 'snake-camel';
import store from '../../store/store';

type Fertilizer = {
    id: string;
    name: string;
    isHidden: boolean;
}

type FertilizersGet = {
    fertilizers: Fertilizer[];
}

@Component({
    components: {
        Modal,
        FertilizerModal
    }
})

export default class FertilizerApprovalModal extends Vue {

    @Prop() showFertilizerApprovalModal!: boolean

    @Prop() fertilizer!: FertilizerModel | null;

    private fertilizers: Fertilizer[] = [];
    private filteredFertilizers: Fertilizer[] = [];
    private selectedFertilizerId: string | null = null;
    private searchText = '';
    private showFertilizerModal = false;
    private isNewFertilizer = false;

    close() {
        this.selectedFertilizerId = null;
        this.searchText = '';
        this.fertilizers = [];
        this.filteredFertilizers = [];
        this.fertilizer = null
        this.$emit('update:showFertilizerApprovalModal', false);
    }

    @Watch('showFertilizerApprovalModal')
    onModalOpen(val: boolean) {
        if (val) {
            this.selectedFertilizerId = null;
            this.getFertilizers(false);
        }
    }

    private selectFertilizer(id: string): void {
        this.selectedFertilizerId = id;
    }

    @Emit('save')
    private save() {
        this.$emit('update:showFertilizerApprovalModal', false);
        return this.selectedFertilizerId ? this.fertilizers.find(f => f.id === this.selectedFertilizerId) ?? null : null;
    }

    @Watch('searchText')
    doSearch() {
        if (this.searchText) {
            const keyword = this.searchText;
            this.filteredFertilizers = this.fertilizers.filter(fertilizer =>
                fertilizer.name.includes(keyword)
            );
        } else {
            this.filteredFertilizers = this.fertilizers;
        }
    }

    private async getFertilizers(withHidden: boolean) {
        try {
            const camelCasedResponse = toCamel(await this.$apiClient.doRequest('get', `/fertilizers/fertilizers_link_master?with_hidden=${withHidden}&&pre_fert_id=${this.fertilizer?.id}`)) as FertilizersGet;
            this.fertilizers = camelCasedResponse.fertilizers;
            this.filteredFertilizers = camelCasedResponse.fertilizers;
        } catch (error) {
            this.$toasted.error('データの取得に失敗しました。');
        }
    }

    openFertilizerModal(): void {
        this.showFertilizerModal = true
        this.isNewFertilizer = true
    }

    onFertilizerCreated(id: string | null): void {
        this.showFertilizerModal = false
        this.isNewFertilizer = false
        this.getFertilizers(false);
        this.selectedFertilizerId = id;
    }
}